import styled from 'styled-components';
export const ThirdPartyAnimationStyled = styled.span `
  display: block;
  width: ${props => props.$width};
  height: ${props => props.$height};
`;
//# sourceMappingURL=thirdPartyAnimation.styled.js.map